import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('SHATTER_GLASS', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const gravity = config.collisionEffectGravity || 0.5;
  for (let i = 0; i < 15; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const speed = 3 + rnd * 5;
    const t = elapsed / 16.6;
    const x = e.pos.x + Math.cos(angle) * speed * t;
    const y = e.pos.y + Math.sin(angle) * speed * t + 0.5 * gravity * t * t;
    const rot = t * (rnd - 0.5);

    ctx.fillStyle = determineColor(i, 15);
    ctx.globalAlpha = 1 - progress;
    ctx.save(); ctx.translate(x, y); ctx.rotate(rot);
    ctx.beginPath(); ctx.moveTo(-5, -5); ctx.lineTo(5, 0); ctx.lineTo(0, 5); ctx.fill();
    ctx.restore();
  }
});
